var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMsgReadIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "10px",
    viewBox: "0 0 18 10",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Combined Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Web_Doctor",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u041B\\u0438\\u0447\\u043D\\u044B\\u0439-\\u043A\\u0430\\u0431\\u0438\\u043D\\u0435\\u0442_\\u043F\\u0430\\u0446\\u0438\\u0435\\u043D\\u0442_\\u043C\\u043E\\u0438-\\u043F\\u0430\\u0446\\u0438\\u0435\\u043D\\u0442\\u044B",
    transform: "translate(-946.000000, -437.000000)",
    fill: "#1373ff",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-23",
    transform: "translate(323.000000, 120.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-35",
    transform: "translate(213.000000, 146.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-24",
    transform: "translate(0.000000, 164.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(410.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(0.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.7592852,0.240714831 C18.0445768,0.526006483 18.0762759,0.968860364 17.8543824,1.28916584 L17.7592852,1.40298885 L9.40298885,9.75928517 C9.08203574,10.0802383 8.56166794,10.0802383 8.24071483,9.75928517 C7.95542318,9.47399352 7.92372411,9.03113964 8.14561761,8.71083416 L8.24071483,8.59701115 L16.5970111,0.240714831 C16.9179643,-0.0802382771 17.4383321,-0.0802382771 17.7592852,0.240714831 Z M13.7623097,0.240714831 C14.0440167,0.526006483 14.0753175,0.968860364 13.8562121,1.28916584 L13.7623097,1.40298885 L5.51101013,9.75928517 C5.22930316,10.0445768 4.79201373,10.0762759 4.47573289,9.85438239 L4.36334006,9.75928517 L0.237690254,5.58113701 C-0.0792300847,5.2601839 -0.0792300847,4.7398161 0.237690254,4.41886299 C0.519397222,4.13357134 0.956686652,4.10187226 1.2729675,4.32376577 L1.38536032,4.41886299 L4.93677884,8.01579497 L12.6146397,0.240714831 C12.93156,-0.0802382771 13.4453894,-0.0802382771 13.7623097,0.240714831 Z",
    id: "Combined-Shape"
  }))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMsgReadIcon);
export default __webpack_public_path__ + "static/media/msg-read-icon.42d938904ff0aa54a6e0b77a9068f057.svg";
export { ForwardRef as ReactComponent };